export const MaintenancePage = () => {
  return (
    <div className="flex h-screen w-full flex-col bg-[#2d2d2d]">
      <div className="flex items-center gap-2 p-6">
        <img src="/predoc_nav_icon.svg" alt="Predoc" className="h-8" />
        <img src="/predoc_text.svg" alt="Predoc" className="h-8" />
      </div>

      <div className="flex flex-1 flex-col items-center justify-center px-4">
        <img
          src="/maintenance-mode.png"
          alt="Maintenance"
          className="mb-8 w-full max-w-md"
        />

        <h1 className="mb-4 text-3xl font-bold text-white">Maintenance Mode</h1>

        <p className="max-w-lg text-center text-gray-300">
          We are updating our system and we will be back online shortly. Please
          contact{' '}
          <a
            href="mailto:support@predoc.ai"
            className="text-gray-300 underline hover:text-white"
          >
            support@predoc.ai
          </a>{' '}
          for immediate assistance.
        </p>
      </div>
    </div>
  );
};
